import React from "react";

import { Formik, Form as FormikForm } from "formik";

import { reset } from "apis/authentication";
import { Button, Typography } from "clearsense-ui/components";
import { Input } from "clearsense-ui/components/formik";

import { forgotPasswordValidationSchema } from "./constants";

const ResetPassword = ({ setIsReset, setResponse }) => {
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await reset({ user: values });
      setResponse(response.status);
      setIsReset(false);
    } catch (error) {
      logger.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Typography
        style="xLarge"
        className="mb-5 text-xl font-normal text-left text-gray-800"
        data-cy="reset-password-header"
      >
        Reset Password
      </Typography>

      <Formik
        initialValues={{ email: "" }}
        onSubmit={handleSubmit}
        validationSchema={forgotPasswordValidationSchema}
      >
        {({ isSubmitting }) => (
          <FormikForm>
            <Input
              required
              label="Email"
              name="email"
              placeholder="oliver@example.com"
              data-cy="login-reset-email-text-field"
            />

            <div className="flex justify-end w-full my-4">
              <Button
                style="text"
                label="Go back to login"
                size="small"
                className="text-xs text-indigo-700"
                onClick={() => setIsReset(false)}
              />
            </div>

            <Button
              fullWidth
              type="submit"
              label="Reset Password"
              data-cy="login-reset-password-button"
              className="h-8"
              loading={isSubmitting}
            />
          </FormikForm>
        )}
      </Formik>
    </>
  );
};

export default ResetPassword;
